import { RouteRecordRaw } from 'vue-router';

let routes: RouteRecordRaw[] = [
	{
		path: '/',
		name: 'login',
		component: () => import('./views/login.vue'),
        meta: {
			closeAppModal: true
        }
	},
	{
		path: '/register',
		name: 'register',
		component: () => import('./views/register.vue'),
        meta: {
        }
	},
	{
		path: '/createCompany/:registrationToken',
		name: 'createCompany',
		component: () => import('./views/createCompany.vue'),
        meta: {
        }
	},
	{
		path: '/registerInvitation/:registrationToken',
		name: 'registerInvitation',
		component: () => import('./views/registerInvitation.vue'),
        meta: {
        }
	},
	{
		path: '/inactive_qr',
		name: 'inactive_qr',
		component: () => import('./views/inactive_qr.vue'),
        meta: {
        }
	},
	{
		path: '/qr_auth/:identifier',
		name: 'qr_auth',
		component: () => import('./views/qr_auth.vue'),
        meta: {
        }
	},
	{
		path: '/requestResetPassword',
		name: 'requestResetPassword',
		component: () => import('./views/requestResetPassword.vue'),
        meta: {
        }
	},
	{
		path: '/resetPassword/:email/:token',
		name: 'resetPassword',
		component: () => import('./views/resetPassword.vue'),
        meta: {
        }
	},
	{
		path: '/confirmRegistration/:confirmationCode',
		name: 'confirmRegistration',
		component: () => import('./views/confirmRegistration.vue'),
        meta: {
        }
	},
];

export default routes;